import { Link, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { ForgotPasswordForm } from '@/components/auth/forgot-password-form';

export const Route = createFileRoute('/_auth/forgot-password')({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage(): React.ReactElement {
  return (
    <section className="border-border bg-card rounded-2xl border p-8 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
      <h1 className="font-display text-2xl tracking-tight">Mot de passe oublié</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        Saisissez votre email — un lien de réinitialisation vous sera envoyé s'il est associé à un
        compte.
      </p>
      <div className="mt-8">
        <ForgotPasswordForm />
      </div>
      <p className="text-muted-foreground mt-6 text-center text-sm">
        <Link to="/sign-in" className="text-primary font-medium hover:underline">
          Retour à la connexion
        </Link>
      </p>
    </section>
  );
}
